import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import CodeInputField from 'components/atoms/FormFields/CodeInputField';
import Checkbox from 'components/atoms/FormFields/Checkbox';
import IntlMessages from 'util/IntlMessages';
import { TWO_FA_CODE_DIVIDER_IDX, TWO_FA_CODE_LENGTH } from 'constants/Misc';

function TwoFaValidator({ handleClick, handleChange, fieldName, trustFieldName }) {
  const [code, setCode] = useState(Array(TWO_FA_CODE_LENGTH).fill(''));
  const [trustDevice, setTrustDevice] = useState(false);

  useEffect(() => {
    handleChange(fieldName, code.join('').trim(''));
  }, [handleChange, code, fieldName]);

  useEffect(() => {
    trustFieldName && handleChange(trustFieldName, trustDevice);
  }, [handleChange, trustDevice, trustFieldName]);

  return (
    <form className="two-fa-modal px-4" onSubmit={(e) => e.preventDefault()}>
      <p className="m-0 font-family-bold text-cripten-primary mb-2 mt-4">
        <IntlMessages id="component.twoFaValidator.title" />
      </p>
      <p className="jr-fs-sm text-gray-light m-0 mb-3">
        <IntlMessages id="component.twoFaValidator.instructions" />
      </p>
      <CodeInputField
        length={TWO_FA_CODE_LENGTH}
        code={code}
        setCode={setCode}
        codeDividerIndex={TWO_FA_CODE_DIVIDER_IDX}
      />
      {trustFieldName && (
        <Checkbox
          className="mt-3 w-fit"
          checked={trustDevice}
          onChange={(e) => setTrustDevice(e.target.checked)}
          label={<IntlMessages id="component.twoFaValidator.trustDevice" />}
        />
      )}
      <button
        className="cripten-btn rounded my-4"
        onClick={() => handleClick(code.join(''))}
        disabled={code.join('').trim('').length < TWO_FA_CODE_LENGTH}
      >
        <IntlMessages id="app.general.actions.continue" />
      </button>
    </form>
  );
}

TwoFaValidator.propTypes = {
  fieldName: PropTypes.string,
  trustFieldName: PropTypes.string,
  handleChange: PropTypes.func,
  handleClick: PropTypes.func,
}.isRequired;

export default TwoFaValidator;
